module.exports = __webpack_public_path__ + "static/logo-ecf.471d730b.png";